module.exports = "<span class=\"link\" (click)=\"clicked()\">\r\n  <ng-content></ng-content>\r\n</span>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/LinkComponent/link.component.html
// module id = ./src/app/common/components/LinkComponent/link.component.html
// module chunks = main